import SideMenuBar from "./components/SideMenuBar.jsx";
import {Bookmark, Briefcase, MessageSquare, User, Menu as MENU, Users, X, Download, FileText, BarChart2, TrendingUp, Calendar, Clock} from "react-feather";
import {useEffect, useState} from "react";
import {AiOutlineComment} from "react-icons/ai";
import {LiaStackExchange} from "react-icons/lia";
import {VscCompassActive} from "react-icons/vsc";
import toast from "../utils/swalToast";
import API_LINK from "../components/links/Link";
import { exportToCSV, exportToPDF, formatAppointmentData, generateDashboardStats } from "../utils/exportUtils";

export default function Dashboard() {
    const [activeDeliveries, setActiveDeliveries] = useState('0')
    const [pastDeliveries, setPastDeliveries] = useState('0')
    const [messages, setMessages] = useState('0')
    const [isMobileShow, setIsMobileShow] = useState(false);
    const [isActiveDeliveriesLoading, setIsActiveDeliveriesLoading] = useState(false)
    const [isPastDeliveriesLoading, setIsPastDeliveriesLoading] = useState(false)
    const [isMessagesLoading, setIsMessagesLoading] = useState(false)
    const [appointmentData, setAppointmentData] = useState([])
    const [isExporting, setIsExporting] = useState(false)

    useEffect(() => {
        LoadAppointmentData();
    }, []);

    const LoadAppointmentData = async () => {
        try {
            let formdata = new FormData();
            if (localStorage.getItem("Role") == "User")
                formdata.append("page", "LoadMyAppointments");
            else
                formdata.append("page", "LoadAppointments");
            formdata.append("id", localStorage.getItem("UserId"));
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            const response = await fetch(`${API_LINK}Appointment.php`, requestOptions);
            const raw = await response.text();
            let result;
            try {
                result = JSON.parse(raw);
            } catch (e) {
                toast.error(`Server response was not JSON: ${raw}`);
                setAppointmentData([]);
                return;
            }

            if (result.status === 1 && Array.isArray(result.data)) {
                setAppointmentData(result.data);
                const activeCount = result.data.filter(a => (a.Status || '').toLowerCase() !== 'done').length;
                const pastCount = result.data.filter(a => (a.Status || '').toLowerCase() === 'done').length;
                setActiveDeliveries(activeCount.toString());
                setPastDeliveries(pastCount.toString());
                setIsActiveDeliveriesLoading(false);
                setIsPastDeliveriesLoading(false);
            } else {
                setAppointmentData([]);
                setActiveDeliveries('0');
                setPastDeliveries('0');
                setIsActiveDeliveriesLoading(false);
                setIsPastDeliveriesLoading(false);
            }
        } catch (e) {
            console.log(e);
            toast.error("Failed to load appointments");
            setAppointmentData([]);
            setActiveDeliveries('0');
            setPastDeliveries('0');
            setIsActiveDeliveriesLoading(false);
            setIsPastDeliveriesLoading(false);
        }
    }

    const handleExportCSV = () => {
        if (appointmentData.length === 0) {
            toast.warning("No data available to export");
            return;
        }
        setIsExporting(true);
        try {
            const formattedData = formatAppointmentData(appointmentData);
            exportToCSV(formattedData, `appointments_${new Date().toISOString().split('T')[0]}.csv`);
            toast.success("Data exported to CSV successfully!");
        } catch (error) {
            toast.error("Failed to export data");
        } finally {
            setIsExporting(false);
        }
    };

    const handleExportPDF = () => {
        if (appointmentData.length === 0) {
            toast.warning("No data available to export");
            return;
        }
        setIsExporting(true);
        try {
            const formattedData = formatAppointmentData(appointmentData);
            exportToPDF(formattedData, `appointments_${new Date().toISOString().split('T')[0]}.pdf`);
            toast.success("PDF report generated successfully!");
        } catch (error) {
            toast.error("Failed to generate PDF");
        } finally {
            setIsExporting(false);
        }
    };

    return (<>
        {/*<MenuHeader page={'dashboard'}/>*/}

            <div className='dashboard-container'>
                <SideMenuBar mobileShow={isMobileShow} onClose={() => setIsMobileShow(false)}/>
                <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16}/>
                        <span>Show Menu</span>
                    </button>
                    <button className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                            onClick={() => setIsMobileShow(false)}>
                        <X size={16}/>
                    </button>
                    <div className="dashboard-header">
                        <div className="welcome-section">
                            <h2>Welcome Back, {localStorage.getItem("UserName")}! 👋</h2>
                            <p>Here's what's happening with your appointments today.</p>
                        </div>
                        <div className="export-actions">
                            <button 
                                className="export-btn csv-btn" 
                                onClick={handleExportCSV}
                                disabled={isExporting}
                            >
                                <Download size={16} />
                                Export CSV
                            </button>
                            <button 
                                className="export-btn pdf-btn" 
                                onClick={handleExportPDF}
                                disabled={isExporting}
                            >
                                <FileText size={16} />
                                Export PDF
                            </button>
                        </div>
                    </div>

                    <div className="dashboard-cards-container">
                        <div className="dashboard-card primary-card">
                            <div className="card-header">
                                <div className="icon">
                                    <VscCompassActive/>
                                </div>
                                <div className="card-trend">
                                    <TrendingUp size={16} />
                                    <span>Active</span>
                                </div>
                            </div>
                            <div className="detail">
                                <h2 className="heading">{isActiveDeliveriesLoading ? '...' : activeDeliveries}</h2>
                                <p>Active Appointments</p>
                                <div className="card-footer">
                                    <Calendar size={14} />
                                    <span>Currently scheduled</span>
                                </div>
                            </div>
                        </div>

                        <div className="dashboard-card success-card">
                            <div className="card-header">
                                <div className="icon">
                                    <LiaStackExchange/>
                                </div>
                                <div className="card-trend">
                                    <BarChart2 size={16} />
                                    <span>Completed</span>
                                </div>
                            </div>
                            <div className="detail">
                                <h2 className="heading">{isPastDeliveriesLoading ? '...' : pastDeliveries}</h2>
                                <p>Past Appointments</p>
                                <div className="card-footer">
                                    <Clock size={14} />
                                    <span>Successfully completed</span>
                                </div>
                            </div>
                        </div>

                        <div className="dashboard-card info-card">
                            <div className="card-header">
                                <div className="icon">
                                    <Users/>
                                </div>
                                <div className="card-trend">
                                    <BarChart2 size={16} />
                                    <span>Total</span>
                                </div>
                            </div>
                            <div className="detail">
                                <h2 className="heading">
                                    {isActiveDeliveriesLoading || isPastDeliveriesLoading ? '...' : parseInt(activeDeliveries) + parseInt(pastDeliveries)}
                                </h2>
                                <p>Total Appointments</p>
                                <div className="card-footer">
                                    <TrendingUp size={14} />
                                    <span>All time</span>
                                </div>
                            </div>
                        </div>

                        <div className="dashboard-card warning-card">
                            <div className="card-header">
                                <div className="icon">
                                    <MessageSquare/>
                                </div>
                                <div className="card-trend">
                                    <BarChart2 size={16} />
                                    <span>Rate</span>
                                </div>
                            </div>
                            <div className="detail">
                                <h2 className="heading">
                                    {isActiveDeliveriesLoading || isPastDeliveriesLoading ? '...' : 
                                        (parseInt(activeDeliveries) + parseInt(pastDeliveries) > 0 
                                            ? ((parseInt(pastDeliveries) / (parseInt(activeDeliveries) + parseInt(pastDeliveries))) * 100).toFixed(1)
                                            : 0)}%
                                </h2>
                                <p>Completion Rate</p>
                                <div className="card-footer">
                                    <BarChart2 size={14} />
                                    <span>Success rate</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-stats-section">
                        <div className="stats-header">
                            <h3>Quick Statistics</h3>
                            <p>Overview of your appointment management</p>
                        </div>
                        <div className="stats-grid">
                            <div className="stat-item">
                                <div className="stat-icon">
                                    <Calendar size={20} />
                                </div>
                                <div className="stat-content">
                                    <h4>Today's Appointments</h4>
                                    <p>Check your schedule for today</p>
                                </div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-icon">
                                    <Clock size={20} />
                                </div>
                                <div className="stat-content">
                                    <h4>Upcoming</h4>
                                    <p>Next 7 days appointments</p>
                                </div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-icon">
                                    <TrendingUp size={20} />
                                </div>
                                <div className="stat-content">
                                    <h4>Performance</h4>
                                    <p>Your appointment success rate</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
